export const useCreateCompanionPortalRoute = (path: string) => {
  return getCompanionPortalRoute({
    path,
    isCompanionHost: useSubdomain().value === "companion",
  });
};
